import type { TechMeans, BaseRequest } from './types';

export type ApiPutDisclosureSettingRequest = TechMeans & BaseRequest;

export const PutDisclosureSetting = Symbol('PutDisclosureSetting');

export interface PutDisclosureSetting {
    putDisclosureSetting(data: ApiPutDisclosureSettingRequest): Promise<void>;
}
